import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login: "",
    loginError: "",
    register: "",
    // Taxable Assessment
    taxableSuccess: "",
    editTaxableSuccess: "",
    // Tax Dec
    taxFormSuccess: "",
    taxFormError: "",
    //
    editTaxForm: "",
    editTaxError: [],
    // exempt
    exemptSuccess: "",
    editExemptSuccess: "",
    // Map Control
    mapSuccess: "",
    editMapSuccess: "",
    //
    ownershipSuccess: "",
    editOwnerSucess: "",
    //
    adminPut: "",
    editProfile: "",
    //
    delTaxForm: "",
    delExemptForm: "",
    delOwnerForm: "",
    delTaxableForm: "",
    delMapForm: "",
    deleteUser: "",
  },
  getters: {},
  mutations: {
    LOGIN_FORM(state, logForm) {
      state.login = logForm;
      localStorage.setItem("login", JSON.stringify(logForm));
      router.push("/home");
    },
    SET_ACCESS_ERROR(state, logForm) {
      state.loginError = logForm;
    },
    REGISTER_SUCCESS(state, regForm) {
      state.register = regForm;
      router.push("/user-control-dashboard");
    },
    // Tax declaration
    TAX_FORM_SUCCESS(state, taxForm) {
      state.taxFormSuccess = taxForm;
    },
    TAX_FORM_ERROR(state, taxForm) {
      state.taxFormError = taxForm;
    },
    //
    EDIT_TAX_FORM(state, editTaxForm) {
      state.editTaxForm = editTaxForm;
    },
    EDIT_TAX_FORM_ERROR(state, editTaxForm) {
      state.editTaxError = editTaxForm;
    },
    TAXABLE_SUCCESS(state, taxableAssessment) {
      state.taxableSuccess = taxableAssessment;
    },
    EDIT_TAXABLE_SUCCESS(state, editTaxableForm) {
      state.editTaxableSuccess = editTaxableForm;
    },
    EXEMPT_SUCCESS(state, exemptAssessment) {
      state.exemptSuccess = exemptAssessment;
    },
    EDIT_EXEMPT_SUCCESS(state, editExemptAssessment) {
      state.editExemptSuccess = editExemptAssessment;
    },
    TAX_MAP_SUCESS(state, mapControl) {
      state.mapSuccess = mapControl;
    },
    EDIT_MAP_SUCCESS(state, editMapControl) {
      state.editMapSuccess = editMapControl;
    },
    OWNER_SUCCESS(state, ownerCard) {
      state.ownershipSuccess = ownerCard;
    },
    OWNER_EDIT_SUCESS(state, ownerPut) {
      state.editOwnerSucess = ownerPut;
    },
    EDIT_USERS_ADMIN(state, adminPut) {
      state.adminPut = adminPut;
    },
    EDIT_PROFILE_SUCCESS(state, editProfile) {
      state.editProfile = editProfile;
    },
    DELETE_TAX_FORM(state, deleteTaxform) {
      state.delTaxForm = deleteTaxform;
      router.push("/tax-declaration-table");
    },
    DELETE_EXEMPT_FORM(state, deleteExemptform) {
      state.delExemptForm = deleteExemptform;
      router.push("/exempt-assessment-dashboard");
    },
    DELETE_OWNER_FORM(state, deleteOwnerform) {
      state.delOwnerForm = deleteOwnerform;
      router.push("/ownership-record-dashboard");
    },
    DELETE_TAXABLE_FORM(state, deleteTaxableform) {
      state.delTaxableForm = deleteTaxableform;
      router.push("/taxable-assessment-dashboard");
    },
    DELETE_MAP_FORM(state, deleteMapform) {
      state.delMapForm = deleteMapform;
      router.push("/tax-map-control-dashboard");
    },
    DELETE_USER_PROFILE(state, deleteUserControlProfile) {
      state.deleteUser = deleteUserControlProfile;
      router.push("/user-control-dashboard");
    },
  },

  actions: {
    loginForm({ commit }, logForm) {
      Vue.prototype.$axios
        .post(`https://wup.pythonanywhere.com/login/`, logForm, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          withCredentials: true,
        })
        .then((logs) => {
          if (logs.data.status == 200) {
            commit(
              "LOGIN_FORM",
              logs.data.data.JWT || logs.data.errors.password[0]
            );
            const message = logs.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(logs);
            const { errors } = logs.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (logs.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((error) => {
      //   console.log("Error:", error);
      // });
    },
    AddUser({ commit }, regForm) {
      Vue.prototype.$axios
        .post(`https://wup.pythonanywhere.com/register/`, regForm, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
          },
        })
        .then((addUser) => {
          if (addUser.data.status == 201 || addUser.data.status == 200) {
            commit("REGISTER_SUCCESS", addUser.data.message);
            const message = addUser.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(addUser);
            const { errors } = addUser.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (addUser.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((err) => {
      //   commit("TAX_FORM_ERROR", err.data.message);
      // });
    },
    taxDeclarationForm({ commit }, taxForm) {
      Vue.prototype.$axios
        .post(`https://wup.pythonanywhere.com/tax-declaration/add/`, taxForm, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
          },
        })
        .then((taxDecForm) => {
          if (taxDecForm.data.status == 201 || taxDecForm.data.status == 200) {
            commit("TAX_FORM_SUCCESS", taxDecForm.data.message);
            const message = taxDecForm.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(taxDecForm);
            const { errors } = taxDecForm.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (taxDecForm.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((err) => {
      //   commit("TAX_FORM_ERROR", err.data.message);
      // });
    },
    editTaxForm({ commit }, editTaxForm) {
      Vue.prototype.$axios
        .put(
          `https://wup.pythonanywhere.com/tax-declaration/update/?id=${editTaxForm.id}`,
          editTaxForm,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((editTaxDecForm) => {
          if (
            editTaxDecForm.data.status == 200 ||
            editTaxDecForm.data.status == 201
          ) {
            console.log(editTaxDecForm.data.errors);
            commit("EDIT_TAX_FORM", editTaxDecForm.data.message);
            const message = editTaxDecForm.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(editTaxDecForm);
            const { errors } = editTaxDecForm.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (editTaxDecForm.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((err) => {
      //   // console.log(err.data);
      //   commit("EDIT_TAX_FORM_ERROR", err.data.errors);
      // });
    },
    taxableAssessmentForm({ commit }, taxableAssessment) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/taxable-assessment-roll/add/`,
          taxableAssessment,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((taxable) => {
          if (taxable.data.status == 200 || taxable.data.status == 201) {
            console.log(taxable);
            commit("TAXABLE_SUCCESS", taxable.data.message);
            const message = taxable.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(taxable);
            const { errors } = taxable.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (taxable.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    taxMapControl({ commit }, mapControl) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/tax-map-control/add/`,
          mapControl,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((map) => {
          if (map.data.status == 200 || map.data.status == 201) {
            console.log(map);
            commit("TAX_MAP_SUCESS", map.data.message);
            const message = map.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(map);
            const { errors } = map.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (map.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((errors) => {
      //   commit("ERROR_LOGIN", errors.data.errors);
      // });
    },
    editMapControl({ commit }, editMapControl) {
      Vue.prototype.$axios
        .put(
          `https://wup.pythonanywhere.com/tax-map-control/update/?id=${editMapControl.id}`,
          editMapControl,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((editMap) => {
          if (editMap.data.status == 200 || editMap.data.status == 201) {
            console.log(editMap);
            commit("EDIT_MAP_SUCCESS", editMap.data.message);
            const message = editMap.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(editMap);
            const { errors } = editMap.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (editMap.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((errors) => {
      //   commit("ERROR_LOGIN", errors.data.errors);
      // });
    },
    editTaxableAssessmentForm({ commit }, editTaxableForm) {
      Vue.prototype.$axios
        .put(
          `https://wup.pythonanywhere.com/taxable-assessment-roll/update/?id=${editTaxableForm.id}`,
          editTaxableForm,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((taxable) => {
          if (taxable.data.status == 200 || taxable.data.status == 201) {
            console.log(taxable);
            commit("EDIT_TAXABLE_SUCCESS", taxable.data.message);
            const message = taxable.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(taxable);
            const { errors } = taxable.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (taxable.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((errors) => {
      //   commit("ERROR_LOGIN", errors.data.errors);
      // });
    },
    exemptAssessmentForm({ commit }, exemptAssessment) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/exempt-assessment-roll/add/`,
          exemptAssessment,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((exempt) => {
          if (exempt.data.status == 200 || exempt.data.status == 201) {
            console.log(exempt);
            commit("EXEMPT_SUCCESS", exempt.data.message);
            const message = exempt.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(exempt);
            const { errors } = exempt.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (exempt.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((errors) => {
      //   commit("ERROR_LOGIN", errors.data.errors);
      // });
    },
    editExemptAssessmentForm({ commit }, editexemptForm) {
      Vue.prototype.$axios
        .put(
          `https://wup.pythonanywhere.com/exempt-assessment-roll/update/?id=${editexemptForm.id}`,
          editexemptForm,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((exempt) => {
          if (exempt.data.status == 200 || exempt.data.status == 201) {
            console.log(exempt);
            commit("EDIT_EXEMPT_SUCCESS", exempt.data.message);
            const message = exempt.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(exempt);
            const { errors } = exempt.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (exempt.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
      // .catch((errors) => {
      //   commit("ERROR_LOGIN", errors.data.errors);
      // });
    },

    ownershipRecordCard({ commit }, ownerCard) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/ownership-record/add/`,
          ownerCard,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((owner) => {
          if (owner.data.status == 200 || owner.data.status == 201) {
            commit("OWNER_SUCCESS", owner.data.message);
            const message = owner.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(owner);
            const { errors } = owner.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (owner.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    newRecordOwnerCard({ commit }, ownerPutCard) {
      Vue.prototype.$axios
        .put(
          `https://wup.pythonanywhere.com/ownership-record/update/?id=${ownerPutCard.id}`,
          ownerPutCard,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((ownerPut) => {
          if (ownerPut.data.status == 200 || ownerPut.data.status == 201) {
            commit("OWNER_EDIT_SUCESS", ownerPut.data.message);
            const message = ownerPut.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(ownerPut);
            const { errors } = ownerPut.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (ownerPut.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    editProfile({ commit }, editProfile) {
      Vue.prototype.$axios
        .put(`https://wup.pythonanywhere.com/update-user/`, editProfile, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
          },
        })
        .then((editProfilePage) => {
          if (
            editProfilePage.data.status == 200 ||
            editProfilePage.data.status == 201
          ) {
            commit("EDIT_PROFILE_SUCCESS", editProfilePage.data.message);
            const message = editProfilePage.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(editProfilePage);
            const { errors } = editProfilePage.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (editProfilePage.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    editUser({ commit }, superAdmin) {
      Vue.prototype.$axios
        .put(
          `https://wup.pythonanywhere.com/user-control/update/?id=${superAdmin.id}`,
          superAdmin,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((editUser) => {
          if (editUser.data.status == 200 || editUser.data.status == 201) {
            commit("EDIT_USERS_ADMIN", editUser.data.message);
            const message = editUser.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(editUser);
            const { errors } = editUser.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (editUser.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    deleteTaxForm({ commit }, deleteTaxform) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/tax-declaration/delete/?id=${deleteTaxform.id}`,
          deleteTaxform,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((delTax) => {
          if (delTax.data.status == 200 || delTax.data.status == 201) {
            commit("DELETE_TAX_FORM", delTax);
            const message = delTax.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(delTax);
            const { errors } = delTax.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (delTax.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    deleteExemptForm({ commit }, deleteExemptform) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/exempt-assessment-roll/delete/?id=${deleteExemptform.id}`,
          deleteExemptform,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((delExempt) => {
          if (delExempt.data.status == 200 || delExempt.data.status == 201) {
            commit("DELETE_EXEMPT_FORM", delExempt);
            const message = delExempt.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(delExempt);
            const { errors } = delExempt.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (delExempt.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    deleteOwnerForm({ commit }, deleteOwnerform) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/ownership-record/delete/?id=${deleteOwnerform.id}`,
          deleteOwnerform,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((delOwner) => {
          if (delOwner.data.status == 200 || delOwner.data.status == 201) {
            commit("DELETE_OWNER_FORM", delOwner);
            const message = delOwner.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(delOwner);
            const { errors } = delOwner.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (delOwner.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    deleteTaxableForm({ commit }, deleteTaxablerform) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/taxable-assessment-roll/delete/?id=${deleteTaxablerform.id}`,
          deleteTaxablerform,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((delTaxable) => {
          if (delTaxable.data.status == 200 || delTaxable.data.status == 201) {
            commit("DELETE_TAXABLE_FORM", delTaxable);
            const message = delTaxable.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(delTaxable);
            const { errors } = delTaxable.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (delTaxable.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    deleteMapForm({ commit }, deleteMapform) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/tax-map-control/delete/?id=${deleteMapform.id}`,
          deleteMapform,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((delMap) => {
          if (delMap.data.status == 200 || delMap.data.status == 201) {
            commit("DELETE_MAP_FORM", delMap);
            const message = delMap.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(delMap);
            const { errors } = delMap.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (delMap.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
    deleteUserControlProfile({ commit }, deleteUserControlProfile) {
      Vue.prototype.$axios
        .post(
          `https://wup.pythonanywhere.com/delete-user/?id=${deleteUserControlProfile.user_id}`,
          deleteUserControlProfile,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "JWT " + JSON.parse(localStorage.getItem("login")),
            },
          }
        )
        .then((delUserProfile) => {
          if (
            delUserProfile.data.status == 200 ||
            delUserProfile.data.status == 201
          ) {
            commit("DELETE_USER_PROFILE", delUserProfile.data.message);
            const message = delUserProfile.data.message;
            Vue.$toast.success(message);
          } else {
            console.log(delUserProfile);
            const { errors } = delUserProfile.data;
            // commit("SET_ACCESS_ERROR", errors);
            if (delUserProfile.data.message === "Token error") {
              Vue.$toast.error(errors);
            } else if (errors) {
              const errorMessages = Object.values(errors).flat();
              errorMessages.forEach((message) => {
                Vue.$toast.error(message);
              });
            }
          }
        });
    },
  },
  modules: {},
});
